import { useState, useEffect } from 'react';

const CommonUtil = {

  isValidCompanyCode(code) {
    if (code === undefined || code === '') return true;
    const regex = /^(?:[a-z0-9]+|[a-z0-9]+_[a-z0-9]+)$/i;
    return regex.test(String(code));
  },

  isValidEmail(email) {
    if (email === undefined || email === '') return true;
    const regex = /^[a-zA-Z0-9_!#$%&'*+/=?`{|}~^-]+(?:\.[a-zA-Z0-9_!#$%&'*+/=?`{|}~^-]+)*@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return regex.test(String(email).toLowerCase());
  },
  isValidPassword(password) {
    if (password === undefined || password === "") return true;
    const re = /^.{0,64}$/;
   return re.test(String(password));
  },
  isValidMobile(mobile) {
    if (mobile === undefined || mobile === '') return true;
    const re = /^(\+\d{1,3}[- ]?)?\d{8,15}$/;
    return re.test(String(mobile));
  },

  isExceptNumericName(name) {
    if (name === undefined || name === '') return true;
    let finalString = name.replace(/[^\d.-]/g, '');
    return finalString;
  },

  isValidName(name) {
    if (name === undefined || name === '') return true;
    let regex = /^[a-zA-Z0-9]+[\s]?[a-zA-Z0-9 ]+$/;
    return regex.test(name);
  },
  isAlphaNumeric(data) {
    if (data === undefined || data === '') return true;
    let regex = /^[a-zA-Z0-9]+$/i;
    return regex.test(data);
  },

  isValidNumericName(name) {
    if (name === undefined || name === '') return true;
    let regex = /^[A-Za-z0-9 ]+$/;
    return regex.test(name);
  },

  isValidNumeric(name) {
    if (name === undefined || name === '') return true;
    let regex = /^[0-9 ]+$/;
    return regex.test(name);
  },
  isValidPasitiveNumeric(name) {
    if (name === undefined || name === '') return true;
    let regex = /^[0-9]+$/;
    return regex.test(name);
  },
  isValidDoubleValue(value) {
    if (value === undefined || value === '') return true;
    let regex = /^[+-]?([1-9][0-9]*|0)(\.[0-9]+)?((e|E)[+-]?[0-9]+)?$/;
    return regex.test(value);
  },

  isValidCode(code) {
    if (code === undefined || code === '') return true;
    let regex = /^[a-zA-Z0-9_-]*$/;
    return regex.test(code);
  },
  isValidZipcode(areaCode) {
    if (areaCode.length < 5 || areaCode.length > 6 || !areaCode.match(/^[0-9 ]+$/)) return true;
  },
  isAlphaNumericSlash(code) {
    if (code === undefined || code === '') return true;
    let regex = /^(?:[A-Za-z0-9]+)(?:[A-Za-z0-9 _]*)$/;
    return regex.test(code);
  },

  isEmptyString(val) {
    if (val === null || val === undefined || val === '') return true;
    else return false;
  },
  isAlphaNumericSpace(data) {
    if (data === undefined || data === '') return true;
    let regex = /^[a-zA-Z0-9_ ]+$/i;
    return regex.test(data);
  },
  isAlphaNumericSpecialChar(data) {
    if (data === undefined || data === '') return true;
    let regex = /^[ A-Za-z0-9_@./#&+-]*$/;
    return regex.test(data);
  },
  isAlphaNumericUnderscore(data) {
    if (data === undefined || data === '') return true;
    let regex = /^[A-Za-z0-9_]*$/;
    return regex.test(data);
  },
  formatDayAndMonth(numValue) {
    if (numValue <= 0) {
      return '-' + (numValue + 12);
    }
    if (numValue < 10) {
      return '-0' + numValue;
    } else {
      return '-' + numValue;
    }
  },

  isEmpty(obj) {
    if (obj === null || obj === undefined) return true;
    return Object.keys(obj).length === 0;
  },

  /**
 * Determines whether a given value logically represents "true".
 * @param {any} value - The value to evaluate.
 * @returns {boolean} - Returns true only if the value logically represents "true".
 */
isTruthyValue(value){
  if (typeof value === "boolean") return value;

  if (typeof value === "number") {
    return value === 1;
  }

  if (typeof value === "string") {
    const lowerValue = value.trim().toLowerCase();
    return lowerValue === "true" || lowerValue === "1";
  }

  return false;
},
parseNumberSafe(value, defaultValue = 0){
  const num = Number(value);
  return Number.isFinite(num) ? num : defaultValue;
},
  //Here taking value as String and converting into numeric  and if value none convertible into string then return  empty string ""
  parseIntoNumeric(value) {
    // Check if the value is numeric
    let numericValue = parseFloat(value);
    // Check if the parsed value is a number and not NaN
    if (!isNaN(numericValue)) {
      // Store only the integer part
      numericValue = Math.floor(numericValue).toString();
    } else {
      // Store empty string if not a valid number
      numericValue = "";
    }
    return numericValue;
  },
  splitPunchDateAndTime(serverTime, splitPunchCondition, splitPunchTimeDuration) {
    let splitPunchTime = serverTime;
    if (CommonUtil.isEmpty(splitPunchCondition) && CommonUtil.isEmpty(splitPunchTimeDuration)) {
      splitPunchTime = serverTime - 2000; //default
    } else if (CommonUtil.isEmpty(splitPunchCondition) && !CommonUtil.isEmpty(splitPunchTimeDuration)) {
      splitPunchTime = splitPunchTimeDuration === "0" ? (serverTime - 2000) : (serverTime - splitPunchTimeDuration * 1000)
    } else if (!CommonUtil.isEmpty(splitPunchCondition) && splitPunchCondition === "0") {
      if (!CommonUtil.isEmpty(splitPunchTimeDuration)) {
        splitPunchTime = splitPunchTimeDuration === "0" ? (serverTime - 2000) : (serverTime - splitPunchTimeDuration * 1000)
      } else {
        splitPunchTime = serverTime - 2000; //default
      }
    } else if (!CommonUtil.isEmpty(splitPunchCondition) && splitPunchCondition === "1") {
      if (!CommonUtil.isEmpty(splitPunchTimeDuration) && splitPunchTimeDuration !== "0") {
        splitPunchTime = serverTime + splitPunchTimeDuration * 1000;
      }
    }
    return splitPunchTime;
  },
  getCompany() {
    return localStorage ? localStorage.getItem('companyId') : null;
  },

  getLocalDate(date) {
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    let newDate = new Date(date);
    let formated =
      newDate.getDate() +
      '-' +
      monthNames[newDate.getMonth()].substring(0, 3) +
      '-' +
      newDate.getFullYear() +
      ', ' +
      (newDate.getHours() < 10 ? '0' + newDate.getHours() : newDate.getHours()) +
      ':' +
      (newDate.getMinutes() < 10 ? '0' + newDate.getMinutes() : newDate.getMinutes()) +
      ':' +
      (newDate.getSeconds() < 10 ? '0' + newDate.getSeconds() : newDate.getSeconds());
    return formated;
  },

  getFormatedDate(date) {
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    let newDate = new Date(date);
    let formated = newDate.getDate() + ', ' + monthNames[newDate.getMonth()] + ' ' + newDate.getFullYear();
    return formated;
  },

  getAttendanceState(code) {
    const eventCode = {
      0: 'Clock In',
      1: 'Clock Out',
      2: 'Meal Start',
      3: 'Meal End',
      4: 'Break Start',
      5: 'Break End',
      8: 'Personal Inbox / View Messages',
      9: 'Accrual Balance',
      10: 'Department Transfer',
      11: 'Offline / Current Schedule',
      12: 'Time-Off Request',
      14: 'Online Schedule',
      15: 'Punch Info',
      18: 'View Timesheet',
      20: 'Meal Waive',
      30: 'Tip Entry',
      40: 'Exempt Check In'
    };
    if (eventCode.hasOwnProperty(code)) {
      return eventCode[code];
    } else {
      return `${code} (Event code)`;
    }
  },

  getPunchMode(code) {
    const punchModeData = {
      1: 'PIN',
      3: 'PIN & Password',
      4: 'Badge',
      5: 'PIN & Badge',
      6: 'Badge & Password',
      8: 'Fingerprint',
      9: 'PIN & Fingerprint',
      10: 'Fingerprint & Password',
      11: 'Pin & Password & Finger',
      12: 'Badge & Fingerprint',
      14: 'Badge & Password & Finger',
      16: 'Face',
      17: 'Face & PIN',
      20: 'Face & Badge',
    };
    if (punchModeData.hasOwnProperty(code)) {
      return punchModeData[code];
    } else {
      return `${code} (Verify mode code)`;
    }
  },

  handleTextOverflow(text) {
    if (text && text.length > 20) {
      return text.substring(0, 20) + '...';
    } else {
      return text;
    }
  },

  getLocalDate1(date) {
    let newDate = new Date(date);
    return newDate
      .toISOString()
      .replace('T', ' ')
      .substr(0, newDate.toISOString().lastIndexOf(':'));
  },

  getLocalTime(time) {
    let newTime = new Date(parseInt(time));
    return newTime.toLocaleTimeString(navigator.language, {
      hour: '2-digit',
      minute: '2-digit',
    });
  },

  sentenceCase(str) {
    if (str === null || str === '') return false;
    else str = str.toString();

    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  },
  formatLongText(text) {
    if (text && text.length > 20) {
      return text.substr(0, 19) + "...";
    } else {
      return text;
    }

  },

  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = 'expires=' + d.toUTCString();
    if (window.location.href.includes('minervaiotdev')) {
      document.cookie = cname + '=' + cvalue + ';' + expires + ';domain=.minervaiotdev.com;path=/';
    } else if (window.location.href.includes('minervaiot')) {
      document.cookie = cname + '=' + cvalue + ';' + expires + ';domain=.minervaiot.com;path=/';
    } else {
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }
  },
  getCookie(cname) {
    let name = cname + '=';
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  },

  getFormatedDateString(date) {
    let today = new Date(date);
    let fdate =
      (today.getDate() < 10 ? '0' + today.getDate() : today.getDate()) +
      '-' +
      (today.getMonth() + 1 < 10 ? '0' + (today.getMonth() + 1) : today.getMonth() + 1) +
      '-' +
      today.getFullYear();
    return fdate;
  },

  GetWindowDimenssion() {
    const [size, setSize] = useState({
      width: window.innerWidth + 'px',
      height: window.innerHeight + 'px',
    });
    const updateSize = () =>
      setSize({
        width: window.innerWidth + 'px',
        height: window.innerHeight + 'px',
      });
    useEffect(() => (window.onresize = updateSize), [size]);
    return size;
  },

  capitalizeFirst(str) {
    return typeof str === 'string' ? str.charAt(0).toUpperCase() + str.slice(1) : str;
  },

  formatDate(timestamp) {
    const options = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    };

    return new Date(timestamp).toLocaleString('en-GB', options).replace(/(\d+)\/(\d+)\/(\d+),? (\d+:\d+:\d+)/, '$1/$2/$3 $4');
  },

  getPageNumber(int) {
    if (int === 0) {
      return 1;
    } else {
      return int + 1;
    }
  },
  isContainsErrorCode(errorCode){
    const errorCodes=[401,500,502]
    return errorCodes.includes(errorCode);
  }

};

export default CommonUtil;
